<div class="spend-chart-value" [ngClass]="{ 'ceg-spend-chart-value': cegFlagEnabled }">
  <div class="content">
    <div class="value">{{ value | number: numberPipeFormat }}<span>%</span></div>
    <ng-content select="[slot=value]"></ng-content>
  </div>
  <div class="remark">
    <ng-content select="[slot=remark]"></ng-content>
  </div>
</div>
